import ArrayUtil from '@leverege/array-util'

import Constants from '~/actions/Constants'
import Items from './Items'

function receive( state, action, resetKeys, copyKeys ) {
  const nState = {
    perPage : action.perPage,
    status : Constants.STATUS_DONE,
    statusMessage : null,
    start : action.start,
    end : action.end,
    next : action.next,
    severity : action.severity,
    search : action.search
  }

  if ( copyKeys ) {
    copyKeys.forEach( ( k ) => {
      nState[k] = action[k]
    } )
  }

  const reset = isReset( state, action, resetKeys ) // ( resetKey != null && action[resetKey] != state[resetKey] )
  if ( reset ) {
    nState.items = []// new Array( action.items.length )
  } else {
    nState.items = [].concat( state.items )
  }

  // copy new items into the array
  nState.items = [].concat( nState.items, action.items )

  return nState
}

function isReset( state, action, resetKeys ) {
  let reset = false
  if ( resetKeys && resetKeys.length > 0 ) {
    resetKeys.forEach( ( key ) => {
      if ( action[key] !== state[key] ) {
        reset = true
      }
    } )
  }
  return reset
}

function reducer( initialState, actionTypeBase, resetKeys, copyKeys ) {

  initialState = {
    status : null,
    statusMessage : null,
    scriptId : null
  }

  const STATUS = Constants[`GET_${actionTypeBase}S_STATUS`]
  const GET = Constants[`GET_${actionTypeBase}S`]

  return function switchCase( state = initialState, action ) {
    switch ( action.type ) {
      case STATUS:
        const nState = { ...state }
        nState.status = action.status
        return nState

      case GET:
        return receive( state, action, resetKeys, copyKeys )
      default:
        return state
    }
  }
}

module.exports = reducer( null, 'SCRIPT_LOG', [ 'scriptId', 'perPage', 'start', 'end', 'severity', 'search' ], [ 'scriptId' ] )
